import { useLayoutEffect, useRef } from "react";
import { StarIcon as StarOutline } from "@heroicons/react/24/outline";
import { StarIcon as StarSolid } from "@heroicons/react/24/solid";

export interface Props {
	score: number;
	stars: number;
	readonly: Boolean;
	onUpdate?: (score: number) => void;
}

export function StarRating(props: Props) {
	const scoreDiv = useRef<HTMLDivElement>(null);
	const starsDiv = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		if (starsDiv.current && scoreDiv.current && starsDiv.current.clientWidth > 0) {
			const width = (starsDiv.current.clientWidth * props.score) / props.stars;
			scoreDiv.current.style.width = `${width}px`;
		}
	}, [props.score, props.stars]);

	const handleClick = (i: number) => {
		if (props.readonly) return;
		props.onUpdate && props.onUpdate(i + 1);
	};

	const gridStyle = {
		display: "inline-grid",
		gridTemplateColumns: "max-content 1fr",
	};

	const rowStyle = {
		gridArea: "1 / 1 / 1 / 1",
		overflow: "hidden",
		whiteSpace: "nowrap" as "nowrap",
	};

	return (
		<>
			<div style={gridStyle}>
				<div ref={starsDiv} style={rowStyle}>
					{[...Array(props.stars)].map((e, i) => (
						<StarOutline
							key={i}
							className={`inline stroke-gray-300 h-6 ${!props.readonly ? "cursor-pointer" : ""}`}
							onClick={() => handleClick(i)}
						/>
					))}
				</div>
				<div ref={scoreDiv} style={rowStyle}>
					{[...Array(props.stars)].map((e, i) => (
						<StarSolid
							key={i}
							className={`inline fill-orange-600 h-6 ${!props.readonly ? "cursor-pointer" : ""}`}
							onClick={() => handleClick(i)}
						/>
					))}
				</div>
			</div>
			{!props.readonly && (
				<p className="italic my-1 text-orange-800">Click on a star to assign a score.</p>
			)}
		</>
	);
}
